export enum FolderActionType {
  NameChange = 'NAME CHANGE'
}
